import * as Yup from 'yup';
import { FC, useState } from 'react';
import { useFormik } from 'formik';
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  MenuItem,
  Typography
} from '@mui/material';
import TextField from '@mui/material/TextField';
import request from '../../../../utils/request';
import { LoadingButton } from '@mui/lab';
import SnackbarAlert from '../../../common/SnackbarAlert';
import React from 'react';
type CreateEditProps = {
  closeCreateEditForm: any;
  CubicCapacityditDatas: any;
  editStatus: boolean;
  productId: any;
  setNewValue?: Function;
};
const CreateEdit: FC<CreateEditProps> = ({
  closeCreateEditForm,
  CubicCapacityditDatas,
  editStatus,
  productId,
  setNewValue
}) => {
  const CubicCapacitySchema = Yup.object().shape({
    range: Yup.string()
      .required('CC Range is required')
      .test(
        'notOnlyWhiteSpace',
        'CC Range cannot include leading and trailing spaces',
        (value) => {
          return !/\s{2,}/.test(value);
        }
      )
      .min(2, 'CC Range must be at least 2 characters'),
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\]*$/,
      //   'CC Range only accepts special characters like &,[,],-,/,(,)'
      // ),
  
    code: Yup.string()
      .required('CC Range Code is required')
      .test(
        'notOnlyWhiteSpace',
        'CC Range Code cannot include leading and trailing spaces',
        (value) => {
          return !/\s{2,}/.test(value);
        }
      )
      .min(2, 'CC Range Code must be at least 2 characters'),
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\]*$/,
      //   'CC Range Code only accepts special characters like &,[,],-,/,(,)'
      // ),
      rate: Yup.number()
      .notRequired()
      .typeError('Rate is not valid')
      .positive('Must be a positive number.')
      .min(1, 'Rate must be greater than or equal to 1')
      .transform((value, originalValue) => {
        return /\s/.test(originalValue) ? NaN : value;
      })
      .test('len', 'Length is too long', (val) => {
        if (val === undefined || val === null) return true;
        const valStr = val.toString();
        const maxLength = valStr.includes('.') ? 10 : 8;
        return valStr.length <= maxLength;
      })
      .test(
        'max-two-decimals',
        'Rate must have at most two decimal places',
        (value) => {
          if (value === undefined || value === null) return true;
          const decimalPlaces = value.toString().split('.')[1];
          return !decimalPlaces || decimalPlaces.length <= 2;
        }
      )
      .nullable()
   
   
  });

  const [loader, setLoader] = useState(false);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const formik = useFormik({
    initialValues: {
      id: '',
      rate: '',
      status: true,
      range: '',
      code: '',
      productId: productId
    },
    validationSchema: CubicCapacitySchema,
    onSubmit: (values) => {
      setLoader(true);
      const method = editStatus ? 'PUT' : 'POST';
      const URL=editStatus ? 'cubicCapacity/update' : 'CubicCapacity/create';
      request({
        url: URL,
        method: method,
        data: values
      })
        .then((response) => {
          if (response.status) {
            closeCreateEditForm(true);
            setLoader(false);
            if (setNewValue) {
              setNewValue(values?.range);
            }
          } else {
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: response['message']
            });
          }
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
        });
    }
  });

  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  if (editStatus) {
    formik.values.id = CubicCapacityditDatas.id;
    formik.initialValues.rate = CubicCapacityditDatas.rate;
    formik.initialValues.range = CubicCapacityditDatas?.range;
    formik.initialValues.code = CubicCapacityditDatas?.code;
  }
  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12} className="">
            <Card>
              {editStatus ? (
                <CardHeader title="Update Cubic Capacity" />
              ) : (
                <CardHeader title="Create Cubic Capacity" />
              )}
              <Divider />

              <CardContent>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            CC Range{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="range"
                        value={capitalizeFirst(formik.values.range)}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          const trimmedValue = e.target.value.trim();
                          formik.setFieldValue('range', trimmedValue);
                          formik.handleBlur(e);
                        }}
                        error={
                          formik.touched.range &&
                          Boolean(formik.errors.range)
                        }
                        helperText={
                          formik.touched.range && formik.errors.range
                        }
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            CC Range Code{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="code"
                        value={formik.values.code}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          const trimmedValue = e.target.value.trim();
                          formik.setFieldValue('code', trimmedValue);
                          formik.handleBlur(e);
                        }}
                        error={
                          formik.touched.code &&
                          Boolean(formik.errors.code)
                        }
                        helperText={
                          formik.touched.code && formik.errors.code
                        }
                      />
                    </Grid>
                   

                    <Grid item xs={6}>
                      <TextField
                        label={<React.Fragment>Rate </React.Fragment>}
                        sx={{ width: '100%' }}
                        size="small"
                        type="text"
                       
                        name="rate"
                        value={capitalizeFirst(formik.values.rate)}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.rate &&
                          Boolean(formik.errors.rate)
                        }
                        helperText={
                          formik.touched.rate &&
                          formik.errors.rate
                        }
                      />
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      mt={2}
                    >
                      {loader ? (
                        <LoadingButton
                          sx={{ mt: { xs: 2, md: 0 } }}
                          loading={loader}
                          variant="contained"
                          type="submit"
                        >
                          Save
                        </LoadingButton>
                      ) : (
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          type="submit"
                          variant="contained"
                        >
                          Save
                        </Button>
                      )}
                      &nbsp;
                      <Button
                        sx={{ mt: { xs: 2, md: 0 } }}
                        variant="contained"
                        color="error"
                        onClick={closeCreateEditForm}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default CreateEdit;
